"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'step.list.title': 'Passi di Onboarding',
    'step.list.empty': 'Nessun passo trovato',
};
